import GetUserContactRequestModelBase from '../_generated/modelBases/get-user-contact-request-model-base';

export default class GetUserContactRequestModel extends GetUserContactRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
